// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { Button, Checkbox } from "antd";
// import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
// import { Tables } from "../../../../../components/Elements/Tables/Tables";
// import { ReactComponent as GreenEye } from "../../../../../assets/svgs/eye-icon.svg";
// import ImportUsers from "../../Users/DailogBoxes/ImportUsers";
// import CreateUsers from "../../Users/DailogBoxes/CreateUsers";
// import { useSelector } from "react-redux";
// import { API_URLS } from "../../../../../api/apiUrls";
// import { getApi } from "../../../../../api/api_instance";
// import CustomSwitch from "../../../../../components/Elements/CustomSwitch/CustomSwitch";
// import { Badge } from "../../../../../components/Elements/TextStyles/Badge";
// import { useNavigate, useLocation } from "react-router-dom";

// const UserTable = ({
//   showCheckboxes,
//   setOpenUserDetailsPage,
//   clientId,
//   selectedRole,
//   setSelectedRows,
//   selectedRows,
//   formId,
//   projectId,
// }) => {
//   const [searchTerm, setSearchTerm] = useState(location.state?.userTableSearch || "");
//   // const [selectedRows, setSelectedRows] = useState([]);
//   const [openAddNewUser, setOpenAddNewUser] = useState(false);
//   const [openImportUser, setOpenImportUser] = useState(false);
//   const [dynamicData, setDynamicData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const [pagination, setPagination] = useState({
//     current: 1,
//     pageSize: 10,
//     total: 0,
//   });
//   // Fetch dynamic data if checkboxes are enabled
//   useEffect(() => {
//     fetchAllUsers(clientId);
//   }, [clientId]);

//   useEffect(() => {
//     if (clientId && selectedRole) {
//       fetchUserData(clientId, formId, projectId);
//     }
//   }, [showCheckboxes, clientId, selectedRole, formId]);

//   const fetchAllUsers = async (clientId) => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_ALL_USER_BY_CLIENT_ID(clientId),
//       });
//       const allUsers = response.data.map((user, index) => ({
//         key: user._id,
//         serial: index + 1,
//         name: user.name,
//         userName: user.employee_id,
//         emailId: user.email,
//         role: Array.isArray(user.role) ? user.role.join(", ") : user.role,
//         status: user.status,
//         action: (
//           <div className="flex gap-3">
//             <GreenEye
//               onClick={() => {
//                 navigate("/organization/user-management/user-details", {
//                   state: { userId: user._id, projectPage: true },
//                 });
//               }}
//             />
//             <CustomSwitch
//               checked={true}
//               onChange={(checked) =>
//                 console.log(`Custom switch toggled, Status: ${checked}`)
//               }
//             />
//           </div>
//         ),
//       }));
//       setDynamicData(allUsers);
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//     }
//   };

//   const fetchUserData = async (clientId, formId, projectId) => {
//     try {
//       setLoading(true);
//       const response = await getApi({
//         apiUrl: API_URLS.GET_STANDARDFORM_ASSIGNED_USER(
//           projectId,
//           formId,
//           clientId,
//           10,
//           1,
//           "createdAt",
//         ),
//       });

//       const allUsers = response.data.map((user, index) => ({
//         key: user._id,
//         serial: index + 1,
//         name: user.name,
//         userName: user.employee_id,
//         emailId: user.email,
//         role: Array.isArray(user.role) ? user.role.join(", ") : user.role,
//         status: user.status,
//         action: (
//           <div className="flex gap-3">
//             <GreenEye
//               onClick={() => {
//                 navigate("/organization/user-management/user-details", {
//                   state: { userId: user._id, projectPage: true },
//                 });
//               }}
//             />
//             <CustomSwitch
//               checked={true}
//               onChange={(checked) =>
//                 console.log(`Custom switch toggled, Status: ${checked}`)
//               }
//             />
//           </div>
//         ),
//       }));

//       const combinedUsers = [...allUsers];

//       const filteredByRole = selectedRole
//         ? combinedUsers.filter((user) =>
//             user.role.toLowerCase().includes(selectedRole.toLowerCase()),
//           )
//         : combinedUsers;

//       setDynamicData(filteredByRole);
//     } catch (error) {
//       setDynamicData([]);
//       console.error("Error fetching user data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Static Table Data (for non-checkbox mode)

//   // const tableData = showCheckboxes ? dynamicData : staticData;

//   const tableData = dynamicData;

//   const headers = useMemo(() => {
//     const baseHeaders = [
//       { label: "Sr. No.", key: "serial" },
//       { label: "Name", key: "name" },
//       { label: "User Name", key: "userName" },
//       { label: "Email Id", key: "emailId" },
//       { label: "Role", key: "role" },
//       { label: "Status", key: "status" },
//       { label: "Action", key: "action" },
//     ];

//     if (showCheckboxes) {
//       baseHeaders.unshift({
//         label: (
//           <Checkbox
//             onChange={(e) =>
//               setSelectedRows(
//                 e.target.checked ? tableData.map((d) => ({ ...d })) : [],
//               )
//             }
//             checked={selectedRows.length === tableData.length}
//           />
//         ),
//         key: "checkbox",
//       });
//     }

//     return baseHeaders;
//   }, [showCheckboxes, selectedRows, tableData]);

//   const filteredData = useMemo(() => {
//     return tableData.filter((item) =>
//       Object.values(item).some((value) =>
//         String(value).toLowerCase().includes(searchTerm.toLowerCase()),
//       ),
//     );
//   }, [searchTerm, tableData]);

//   const handleRowSelect = useCallback(
//     (key) => {
//       const selectedRowData = tableData.find((row) => row.key === key);

//       setSelectedRows((prevSelected) => {
//         const alreadySelected = prevSelected.find((row) => row.key === key);
//         if (alreadySelected) {
//           return prevSelected.filter((row) => row.key !== key);
//         } else {
//           return [...prevSelected, selectedRowData];
//         }
//       });
//     },
//     [tableData],
//   );

//   const tableRows = useMemo(() => {
//     return filteredData.map((row) => ({
//       ...row,
//       ...(showCheckboxes && {
//         checkbox: (
//           <Checkbox
//             checked={selectedRows.some((r) => r.key === row.key)}
//             onChange={() => handleRowSelect(row.key)}
//           />
//         ),
//       }),
//       status: <Badge text={row.status} />,
//       // action: (
//       //   <div className="flex gap-3">
//       //     <GreenEye
//       //       onClick={() => {
//       //         console.log(`View user: ${user._id}`);
//       //         navigate("/organization/user-management/user-details");
//       //       }}
//       //     />
//       //     <CustomSwitch
//       //       checked={true}
//       //       onChange={(checked) =>
//       //         console.log(`Custom switch toggled, Status: ${checked}`)
//       //       }
//       //     />
//       //   </div>
//       // ),
//     }));
//   }, [filteredData, showCheckboxes, selectedRows, handleRowSelect]);
//   return (
//     <div>
//       {showCheckboxes && (
//         <div className="flex gap-8 items-center mb-4 mx-4">
//           <div className="border border-4-solid boder-grey-400 px-4 py-2 rounded-md">
//             <Checkbox
//               onChange={(e) =>
//                 setSelectedRows(
//                   e.target.checked ? tableData.map((d) => d.key) : [],
//                 )
//               }
//               checked={selectedRows.length === tableData.length}
//             >
//               <p className="text-sm font-light">Select All </p>
//             </Checkbox>
//           </div>
//           <SearchBar width="300px" onSearch={setSearchTerm} />
//         </div>
//       )}
//       <div
//         style={{
//           border: "1px solid #3BA2B959",
//           borderRadius: "10px",
//           backgroundColor: "#fff",
//         }}
//       >
//         {!showCheckboxes && (
//           <div className="flex justify-between mx-10">
//             <div className="flex gap-8 my-4 font-medium">
//               <p className="text-[#06513D] pt-2">USER</p>
//               <SearchBar width="300px" onSearch={setSearchTerm} />
//             </div>
//             {/* <div className="flex gap-2 mb-2">
//               <Button
//                 type="primary"
//                 style={{
//                   background: "#0087A3",
//                   height: "50px",
//                   width: "150px",
//                   borderRadius: "10px",
//                 }}
//                 className="text-xs font-light"
//               >
//                 Export
//               </Button>

//               <Button
//                 type="primary"
//                 style={{
//                   background: "#0087A3",
//                   height: "50px",
//                   width: "150px",
//                   borderRadius: "10px",
//                 }}
//                 className="text-xs font-light"
//                 onClick={() => setOpenImportUser(true)}
//               >
//                 Import
//               </Button>
//               <Button
//                 type="primary"
//                 style={{
//                   background: "#0087A3",
//                   height: "50px",
//                   width: "150px",
//                   borderRadius: "10px",
//                 }}
//                 className="text-xs font-light"
//                 onClick={() => {
//                   setOpenAddNewUser(true);
//                 }}
//               >
//                 Add New
//               </Button>
//             </div> */}
//           </div>
//         )}

//         <Tables data={tableRows} headers={headers} loading={loading} />

//         {openAddNewUser && (
//           <CreateUsers
//             onOpen={openAddNewUser}
//             onClose={() => setOpenAddNewUser(false)}
//           />
//         )}
//         {openImportUser && (
//           <ImportUsers
//             onOpen={openImportUser}
//             onClose={() => setOpenImportUser(false)}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default UserTable;

import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Button, Checkbox } from "antd";
import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../../../components/Elements/Tables/Tables";
import { ReactComponent as GreenEye } from "../../../../../assets/svgs/eye-icon.svg";
import ImportUsers from "../../Users/DailogBoxes/ImportUsers";
import CreateUsers from "../../Users/DailogBoxes/CreateUsers";
import { useSelector } from "react-redux";
import { API_URLS } from "../../../../../api/apiUrls";
import { getApi, putApi } from "../../../../../api/api_instance";
import CustomSwitch from "../../../../../components/Elements/CustomSwitch/CustomSwitch";
import { Badge } from "../../../../../components/Elements/TextStyles/Badge";
import { useNavigate, useLocation } from "react-router-dom";
import PopupCard from "../../../../Auth/PopupCard";
import UserFilter from "../DailogBoxes/UserFilter";
import { ReactComponent as FilterIcon } from "../../../../../assets/svgs/filter-icon.svg";
// Hook to detect screen size
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

const UserTable = ({
  showCheckboxes,
  setOpenUserDetailsPage,
  clientId,
  selectedRole,
  setSelectedRows,
  selectedRows,
  formId,
  projectId,
  userDataChangeShow = true,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [openAddNewUser, setOpenAddNewUser] = useState(false);
  const [openImportUser, setOpenImportUser] = useState(false);
  const [dynamicData, setDynamicData] = useState([]);
  const [loading, setLoading] = useState(false);
  const user_data = useSelector((state) => state.auth.user);
  const location = useLocation();

  const [currentPage, setCurrentPage] = useState(
    location.state?.userTablePage || 1,
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [openFilter, setOpenFilter] = useState(false);
  const [filterData, setFilterData] = useState(
    location.state?.userTableFilterData || { status: "", role: "" },
  );
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const triggerPopup = (type, title, message, duration = 2000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), duration);
  };
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (
      location.state?.userTablePage !== currentPage ||
      location.state?.userTableSearch !== searchTerm ||
      location.state?.userTableFilterData !== filterData
    ) {
      navigate(".", {
        replace: true,
        state: {
          ...location.state,
          userTablePage: currentPage,
          userTableSearch: searchTerm,
          userTableFilterData: filterData,
        },
      });
    }
  }, [currentPage, searchTerm, filterData, navigate, location.state]);

  // 🔹 Debounce searchTerm so API doesn't fire on every keystroke
  const [debouncedSearch, setDebouncedSearch] = useState(searchTerm);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500); // 500ms delay after typing stops
    return () => clearTimeout(handler);
  }, [searchTerm]);

  useEffect(() => {
    if (clientId) {
      fetchAllUsers(clientId, debouncedSearch);
    }
  }, [clientId, currentPage, pageSize, debouncedSearch, filterData]);

  useEffect(() => {
    if (userDataChangeShow) {
      if (clientId && selectedRole) {
        fetchUserData(clientId, formId, projectId);
      }
    }
  }, [showCheckboxes, clientId, selectedRole, formId]);
  const handleToggleStatus = async (userId, currentStatus) => {
    try {
      const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

      const response = await putApi({
        apiUrl: API_URLS.UPDATE_USER(userId),
        data: { status: newStatus },
      });

      if (response?.success) {
        triggerPopup(
          "success",
          "Status Updated",
          `User status changed to ${newStatus} successfully`,
        );
        fetchAllUsers(clientId, debouncedSearch);
        // fetchAllUsers();
      } else {
        triggerPopup(
          "error",
          "Update Failed",
          response?.message || "Failed to update user status",
        );
      }
    } catch (error) {
      console.error("Error updating user status:", error);
      triggerPopup(
        "error",
        "Update Failed",
        "Something went wrong while updating user status",
      );
    }
  };
  const fetchAllUsers = async (clientId, searchTerm = "") => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_ALL_USER_BY_CLIENT_ID(
          clientId,
          currentPage,
          pageSize,
          searchTerm, // <-- pass search term to API
          filterData,
        ),
      });

      const { data, total, limit } = response; // total records returned from API

      const allUsers = data.map((user, index) => ({
        key: user._id,
        serial: (currentPage - 1) * (limit || pageSize) + index + 1,
        name: <div className="text-center">{user.name}</div>,
        userName: <div className="text-center">{user.employee_id}</div>,
        emailId: <div className="text-center">{user.email}</div>,
        role: (
          <div className="text-center capitalize">
            {Array.isArray(user.role) ? user.role.join(", ") : user.role}
          </div>
        ),
        status: <div className="text-center">{user.status}</div>,
        action: (
          <div className="flex gap-3 items-center justify-center">
            <GreenEye
              onClick={() => {
                navigate("/organization/user-management/user-details", {
                  state: {
                    userId: user._id,
                    projectPage: true,
                    source: "user-table-project",
                    userTablePage: currentPage,
                    userTableSearch: searchTerm,
                    userTableFilterData: filterData,
                    projectPageLocationState: location.state,
                  },
                });
              }}
            />
            <CustomSwitch
              checked={user.status === "Active"}
              onChange={() => handleToggleStatus(user._id, user.status)}
            />
          </div>
        ),
      }));

      setDynamicData(allUsers);
      setTotalRecords(total || data.length);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);
  const fetchUserData = async (clientId, formId, projectId) => {
    try {
      setLoading(true);
      const response = await getApi({
        apiUrl: API_URLS.GET_STANDARDFORM_ASSIGNED_USER(
          projectId,
          formId,
          clientId,
          pageSize,
          currentPage,
          "createdAt",
        ),
      });

      // const allUsers = response.data.map((user, index) => ({
      //   key: user._id,
      //   serial: index + 1,
      //   name: user.name,
      //   userName: user.employee_id,
      //   emailId: user.email,
      //   role: Array.isArray(user.role) ? user.role.join(", ") : user.role,
      //   status: user.status,
      //   action: (
      //     <div className="flex gap-3">
      //       <GreenEye
      //         onClick={() => {
      //           navigate("/organization/user-management/user-details", {
      //             state: { userId: user._id, projectPage: true },
      //           });
      //         }}
      //       />
      //       <CustomSwitch
      //         checked={true}
      //         onChange={(checked) =>
      //           console.log(`Custom switch toggled, Status: ${checked}`)
      //         }
      //       />
      //     </div>
      //   ),
      // }));
      // .centerText {
      //   text-align: center !important;
      // }
      const allUsers = response.data.map((user, index) => ({
        key: user._id,
        serial: <div style={{ textAlign: "center!imprtant" }}>{index + 1}</div>,
        name: (
          <div className="text-center" title="">
            {user.name}
          </div>
        ),
        userName: (
          <div className="text-center" title="">
            {user.employee_id}
          </div>
        ),
        emailId: <div className="text-center">{user.email}</div>,
        role: (
          <div className="text-center">
            {Array.isArray(user.role) ? user.role.join(", ") : user.role}
          </div>
        ),
        status: (
          <div
            className="  font-normal py-1 text-center   rounded-md flex justify-center items-center"
            title=""
          >
            {user.status}
          </div>
        ),
        action: (
          <div className="flex justify-center items-center gap-3" title="">
            <GreenEye
              onClick={() => {
                navigate("/organization/user-management/user-details", {
                  state: { userId: user._id, projectPage: true },
                });
              }}
            />
            <CustomSwitch
              checked={true}
              onChange={(checked) =>
                console.log(`Custom switch toggled, Status: ${checked}`)
              }
              title=""
            />
          </div>
        ),
      }));

      const filteredByRole = selectedRole
        ? allUsers.filter((user) =>
            user.role.toLowerCase().includes(selectedRole.toLowerCase()),
          )
        : allUsers;

      setDynamicData(filteredByRole);
    } catch (error) {
      setDynamicData([]);
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };

  const tableData = dynamicData;

  const headers = useMemo(() => {
    const baseHeaders = [
      { label: "Sr. No.", key: "serial" },
      { label: "Name", key: "name" },
      { label: "User ID", key: "userName" },
      { label: "Email Id", key: "emailId" },
      { label: "Role", key: "role" },
      { label: "Status", key: "status" },
      { label: "Action", key: "action" },
    ];

    if (showCheckboxes) {
      baseHeaders.unshift({
        label: (
          <Checkbox
            onChange={(e) =>
              setSelectedRows(
                e.target.checked ? tableData.map((d) => ({ ...d })) : [],
              )
            }
            checked={selectedRows.length === tableData.length}
          />
        ),
        key: "checkbox",
      });
    }

    return baseHeaders;
  }, [showCheckboxes, selectedRows, tableData]);

  // const filteredData = useMemo(() => {
  //   return tableData.filter((item) =>
  //     Object.values(item).some((value) =>
  //       String(value).toLowerCase().includes(searchTerm.toLowerCase()),
  //     ),
  //   );
  // }, [searchTerm, tableData]);

  const handleRowSelect = useCallback(
    (key) => {
      const selectedRowData = tableData.find((row) => row.key === key);

      setSelectedRows((prevSelected) => {
        const alreadySelected = prevSelected.find((row) => row.key === key);
        if (alreadySelected) {
          return prevSelected.filter((row) => row.key !== key);
        } else {
          return [...prevSelected, selectedRowData];
        }
      });
    },
    [tableData],
  );

  const tableRows = useMemo(() => {
    return dynamicData.map((row) => ({
      ...row,
      ...(showCheckboxes && {
        checkbox: (
          <Checkbox
            checked={selectedRows.some((r) => r.key === row.key)}
            onChange={() => handleRowSelect(row.key)}
          />
        ),
      }),
      status: (
        <div className="flex justify-center items-center w-full">
          <Badge text={row.status} widthsize="w-14" />
        </div>
      ),
    }));
  }, [dynamicData, showCheckboxes, selectedRows, handleRowSelect]);

  return (
    <div>
      {showCheckboxes && (
        <div className="flex gap-8 items-center mb-4 mx-4">
          <div className="border border-4-solid border-gray-400 px-4 py-2 rounded-md">
            <Checkbox
              onChange={(e) =>
                setSelectedRows(
                  e.target.checked ? tableData.map((d) => d.key) : [],
                )
              }
              checked={selectedRows.length === tableData.length}
            >
              <p className="text-sm font-light">Select All</p>
            </Checkbox>
          </div>
          <SearchBar
            width="100%"
            onSearch={(value) => {
              setSearchTerm(value); // triggers debounce
              setCurrentPage(1); // reset to first page
            }}
          />
        </div>
      )}

      <div
        className="overflow-hidden pb-4"
        style={{
          border: "1px solid #3BA2B959",
          borderRadius: "10px",
          backgroundColor: "#fff",
          overflow: "hidden",
        }}
      >
        {!showCheckboxes && (
          <div className="flex justify-between items-center mx-4 sm:mx-10 my-4">
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-8 font-medium flex-1">
              <p className="text-[#06513D] pt-1 text-base">USER</p>

              <div className="w-full sm:w-[300px]">
                <SearchBar
                  width="100%"
                  onSearch={(value) => {
                    setSearchTerm(value);
                    setCurrentPage(1);
                  }}
                />
              </div>
            </div>

            <Button
              onClick={() => setOpenFilter(true)}
              style={{
                color: "#06513D",
                background: "#E6EDEB",
                border: "solid 1px #06513D",
              }}
              className="text-[12px] hover:!bg-[#F8F8F8]  text-[#06513D] font-light px-4 py-5 ml-4"
            >
              <FilterIcon /> FILTER
            </Button>
          </div>
        )}

        {/* TABLE for desktop, CARDS for mobile */}
        {isMobile ? (
          <div className="space-y-4 p-4">
            {/* Mobile heading and search bar */}

            {tableRows.map((user) => (
              <div
                key={user.key}
                className="border border-gray-200 rounded-xl shadow-sm p-4 bg-white text-sm space-y-2"
              >
                <div className="flex justify-between">
                  <span className="text-gray-500 font-medium">#</span>
                  <span className="text-gray-700">{user.serial}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500 font-medium">Name</span>
                  <span className="text-gray-800">{user.name}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500 font-medium">User ID</span>
                  <span className="text-gray-800">{user.userName}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500 font-medium">Email</span>
                  <span className="text-gray-800">{user.emailId}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500 font-medium">Role</span>
                  <span className="text-gray-800">{user.role}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500 font-medium">Status</span>
                  <span>{user.status}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <Tables
            data={tableRows}
            headers={headers}
            loading={loading}
            pageSize={pageSize}
            total={totalRecords}
            current={currentPage}
            onChange={handlePageChange}
            className="min-w-full"
          />
        )}

        {openAddNewUser && (
          <CreateUsers
            onOpen={openAddNewUser}
            onClose={() => setOpenAddNewUser(false)}
          />
        )}
        {openImportUser && (
          <ImportUsers
            onOpen={openImportUser}
            onClose={() => setOpenImportUser(false)}
          />
        )}
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
            />
          </div>
        )}
        {openFilter && (
          <UserFilter
            onOpen={openFilter}
            onClose={() => setOpenFilter(false)}
            setFilterData={setFilterData}
            initialFilter={filterData}
          />
        )}
      </div>
    </div>
  );
};

export default UserTable;
